var exports = {
  "kL": "CreateDMBottomSheet.module__container___Z3NFVz",
  "XG": "CreateDMBottomSheet.module__scroller___Z3NFVz",
  "Qs": "CreateDMBottomSheet.module__content___Z3NFVz",
  "h_": "CreateDMBottomSheet.module__description___Z3NFVz",
  "ov": "CreateDMBottomSheet.module__friendSelector___Z3NFVz",
  "qr": "CreateDMBottomSheet.module__footer___Z3NFVz",
  "x7": "CreateDMBottomSheet.module__cancelButton___Z3NFVz",
  "Tf": "CreateDMBottomSheet.module__createButton___Z3NFVz",
};

module.exports = exports;
